import { Directive, ViewContainerRef, ComponentRef, Input, TemplateRef } from '@angular/core';

import { RxSpinnerComponent } from './spinner/rx-spinner.component';

@Directive({
  selector: '[rxSpinner]',
})
export class RxSpinnerDirective {
  public spinnerComponent: ComponentRef<RxSpinnerComponent>;

  @Input()
  public set rxSpinner(loading: boolean) {
    this.vcRef.clear();

    if (loading) {
      this.spinnerComponent = this.vcRef.createComponent(RxSpinnerComponent);
    } else {
      this.vcRef.createEmbeddedView(this.templateRef);
    }
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private vcRef: ViewContainerRef,
  ) {}
}
